import styled from "styled-components";
import colors from "../../../../../styles/colors";
import { SectionTitle } from "../../common/Charts.styles";

export const LanguageSectionTitle = styled(SectionTitle as any)`
  margin-left: 0.5rem;
`;

export const SelectLanguageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Select = styled.select`
  padding: 1rem 0.5rem;
  display: block;
  width: 225px;
  height: 100%;
  background-color: ${colors.white};
  border-color: transparent;
  border-bottom: 5px solid ${colors.chartLightBlue100};
  font: inherit;
  font-weight: bolder;
  color: #21394f;
  font-size: 2rem;
`;

export const LanguageSelectionSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
`;
